// extracted by mini-css-extract-plugin
export var colorSquare = "_mu-0";
export var container = "_mu-h";
export var danger = "_mu-5";
export var lightPink = "_mu-8";
export var neutralBlue = "_mu-7";
export var neutralYellow = "_mu-6";
export var normal = "_mu-1";
export var primary = "_mu-2";
export var primaryLight = "_mu-3";
export var selected = "_mu-i";
export var solidBlack = "_mu-g";
export var solidGreen = "_mu-b";
export var solidLightBlue = "_mu-d";
export var solidNavy = "_mu-c";
export var solidOrange = "_mu-f";
export var solidPink = "_mu-e";
export var solidRed = "_mu-9";
export var solidYellow = "_mu-a";
export var success = "_mu-4";